import { Metadata } from '@memberjunction/core';

/**
 * MJ role names held by the signed-in user.
 *
 * Read straight from metadata rather than a view: `CurrentUser.UserRoles` is
 * already loaded as part of the user object the shell resolved at startup, so
 * this is a field access, not a query (dev-best-practices §6 — check for an
 * existing cache before running a view).
 *
 * Call only after the readiness gate resolves; before that `CurrentUser` may be
 * absent and this returns empty, which every caller must treat as "entitled to
 * nothing" rather than "no restrictions".
 */
export function CurrentUserRoleNames(): readonly string[] {
    const md = new Metadata();
    const userRoles = md.CurrentUser?.UserRoles ?? [];
    const names: string[] = [];
    for (const userRole of userRoles) {
        // `Role` is the role NAME on MJ's UserRoleEntity view, not an object.
        if (userRole.Role) {
            names.push(userRole.Role);
        }
    }
    return names;
}
